import * as React from "react"
import NavItem from '../Header/NavItem';

const Logo = () => {
  return (
    <NavItem path={"/"}>
      <svg
        width={44}
        height={44}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#prefix__clip0)">
          <path d="M.003 0H44v44H.003V0z" fill="#5686F5"/>
          <path
            d="M2.244 17.228c3.494-3.113 6.832-6.402 10.249-9.603 1.343-1.261 2.717-2.492 4.075-3.734.11.055.22.112.33.17v1.41c0 4.6.014 9.198-.016 13.797-.006.963.295 1.517 1.276 1.785 1.21.33 2.373.822 3.563 1.225 1.56.527 2.76 1.428 3.32 3.04.619 1.769 1.95 2.439 3.743 2.71 2.388.362 4.77.865 7.094 1.52 1.675.472 1.977 1.346 1.175 2.875-.8 1.535-1.739 3-2.668 4.462-.603.95-1.51 1.373-2.652 1.343-1.39-.034-2.793.13-4.164-.028-3.645-.423-6.81.567-9.694 2.802-.783.61-1.084 1.009-.424 1.843.308.387.512.853.801 1.377H-.677V20.886c.817-1.334 1.721-2.586 2.921-3.658zm10.892 2.5c.8.098 1.583.363 2.576.603V7.957l-.292-.082c-.174.554-.35 1.105-.52 1.662-.875 2.903-1.719 5.812-2.638 8.702-.296.929-.153 1.364.874 1.49z"
            fill="#0D1117"
          />
        </g>
        <defs>
          <clipPath id="prefix__clip0">
            <path
              fill="#fff"
              transform="matrix(-1 0 0 1 43.997 0)"
              d="M0 0h43.997v44H0z"
            />
          </clipPath>
        </defs>
      </svg>
    </NavItem>
  )
}

export default Logo;